import { FormattedEmailTemplate } from "@idw-types/data/email-template";

export enum EmailTemplateDetailsActionTypes {
    // Email Template Details
    SET_EMAIL_TEMPLATE_DETAILS_LOADING = "SET_EMAIL_TEMPLATE_DETAILS_LOADING",
    SET_EMAIL_TEMPLATE_DETAILS = "SET_EMAIL_TEMPLATE_DETAILS"
}

// Email Template Details
type SetEmailTemplateDetailsLoadingAction = {
    type: EmailTemplateDetailsActionTypes.SET_EMAIL_TEMPLATE_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setEmailTemplateDetailsLoading = (isLoading: boolean): SetEmailTemplateDetailsLoadingAction => ({
    type: EmailTemplateDetailsActionTypes.SET_EMAIL_TEMPLATE_DETAILS_LOADING,
    payload: { isLoading }
});

type SetEmailTemplateDetailsAction = {
    type: EmailTemplateDetailsActionTypes.SET_EMAIL_TEMPLATE_DETAILS,
    payload: { emailTemplate: FormattedEmailTemplate; }
}

export const setEmailTemplateDetails = (emailTemplate: FormattedEmailTemplate): SetEmailTemplateDetailsAction => ({
    type: EmailTemplateDetailsActionTypes.SET_EMAIL_TEMPLATE_DETAILS,
    payload: { emailTemplate }
});


export type EmailTemplateDetailsActions =
    // Email Template Details
    SetEmailTemplateDetailsLoadingAction |
    SetEmailTemplateDetailsAction